// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__yJlMQ","info":"Panel_info__PBKwQ","btns":"Panel_btns__wvoMS","button":"Panel_button__t6F2w"};